<!-- Updated HTML template -->
<section class="cmn-innerpage-wrapper">
  <div class="inner-content dashboard">
    <div class="tabGroupWrapper">
      <div class="agGrid-wrapper">
        <div class="head">
          <div class="search-wrapper">
            <input type="text" class="cmn-header-search" placeholder="Search users"
              (input)="onAppUsersSearch($event)" />
          </div>
          <div class="d-flex justify-content-end total-users">
            Total Users: {{totalItems}}
          </div>
          <div class="head-actions">
            <button class="icon-btn" (click)="openFilterDialog()" title="Advanced Filters">
              <img src="assets/images/icons/filter.svg" alt="Add icon" />
            </button>

            <button class="icon-btn" (click)="exportUsers()" title="Export Users">
              <img src="assets/images/icons/export.svg" alt="Add icon" />
            </button>
          </div>

        </div>

        <div class="agGrid-wrapper">
          <ag-grid-angular [theme]="'legacy'" style="width: 100%" [rowData]="rowData" [columnDefs]="columnDefs"
            [defaultColDef]="defaultColDef" [rowSelection]="rowSelection" [suppressRowClickSelection]="true"
            [pagination]="true" [paginationPageSize]="paginationPageSize"
            [paginationPageSizeSelector]="paginationPageSizeSelector" [class]="themeClass"
            (rowClicked)="onRowClicked($event)">
          </ag-grid-angular>


          <div class="pagination-wrapper">
            <div class="page-size" style="display: flex; align-items: center;">
              <label for="pageSize">
                <div>Page Size:</div>
              </label>
              <select id="pageSize" [(ngModel)]="pageSize" (change)="onPageSizeChange($event)" class="filter-select">
                <option *ngFor="let size of pageSizeOptions" [value]="size">
                  {{ size }}
                </option>
              </select>
            </div>
            <div class="page-nav">
              <button class="prev" (click)="prevPage()" [disabled]="page === 0">
                <img src="../../../assets/images/icons/arrow.svg" alt="prev arrow" srcset="" />
              </button>
              <span> Page {{ page + 1 }} of {{ totalPages }} </span>
              <button class="next" (click)="nextPage()" [disabled]="page + 1 >= totalPages">
                <img src="../../../assets/images/icons/arrow.svg" alt="next arrow" srcset="" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
